import useCustomEffect from "../../../../../../hooks/useCustomEffect";
import QuestionnaireFormView from "./QuestionnaireFormView";

function QuestionnaireForm({
  relations,
  fetchRelation,
  selectedStep,
  selectedStepIndex,
  setFlowData,
  submitError,
}) {
  /**
   * This effect will fetch the questionnaires relation on mount.
   */
  useCustomEffect(() => {
    fetchRelation("questionnaires");
  }, []);

  /**
   * This method will handle the on questionnaire change event
   * @param {int} questionnaireId
   */
  function onQuestionnaireChange(questionnaireId) {
    setFlowData((prev) => ({
      ...prev,
      steps: prev.steps.map((step) => {
        if (step.id === selectedStep.id) {
          return {
            ...step,
            questionnaire_id: questionnaireId,
          };
        }
        return step;
      }),
    }));
  }

  /**
   * This method will handle the on proceed on error change event
   * @param {bool} proceedOnError
   */
  function onProceedOnErrorChange(proceedOnError) {
    setFlowData((prev) => ({
      ...prev,
      steps: prev.steps.map((step) => {
        if (step.id === selectedStep.id) {
          return {
            ...step,
            proceed_on_error: proceedOnError,
          };
        }
        return step;
      }),
    }));
  }

  /**
   * This method will handle the on questionnaire expiration change event
   * @param {event} e
   */
  function onQuestionnaireExpirationChange(e) {
    setFlowData((prev) => ({
      ...prev,
      steps: prev.steps.map((step) => {
        if (step.id === selectedStep.id) {
          return {
            ...step,
            questionnaire_expiration: e.target.value,
          };
        }
        return step;
      }),
    }));
  }

  /**
   * This method will handle the on link to houserules change event
   * @param {boolean} linkToHouserules
   */
  function onLinkToHouserulesChange(linkToHouserules) {
    setFlowData((prev) => ({
      ...prev,
      steps: prev.steps.map((step) => {
        if (step.id === selectedStep.id) {
          return {
            ...step,
            link_to_houserules: linkToHouserules,
          };
        }
        return step;
      }),
    }));
  }

  return (
    <QuestionnaireFormView
      relations={relations}
      selectedStep={selectedStep}
      selectedStepIndex={selectedStepIndex}
      onQuestionnaireChange={onQuestionnaireChange}
      onProceedOnErrorChange={onProceedOnErrorChange}
      onQuestionnaireExpirationChange={onQuestionnaireExpirationChange}
      onLinkToHouserulesChange={onLinkToHouserulesChange}
      submitError={submitError}
    />
  );
}

export default QuestionnaireForm;
